import { render, staticRenderFns } from "./GiveBackAccessToEmployeeModal.vue?vue&type=template&id=d95d2824&scoped=true"
import script from "./GiveBackAccessToEmployeeModal.vue?vue&type=script&lang=js"
export * from "./GiveBackAccessToEmployeeModal.vue?vue&type=script&lang=js"
import style1 from "./GiveBackAccessToEmployeeModal.vue?vue&type=style&index=1&id=d95d2824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d95d2824",
  null
  
)

export default component.exports